<template>
  <div>
    <span class='headline text-uppercase'>{{ title }}</span><br>
    <span class='body-1'>{{ subtitle }}</span>
  </div>
</template>

<script>

export default {
  name: 'report-title',
  props: {
    title: {
      required: true
    },
    subtitle: {
      required: true
    }
  }
}
</script>
